// removed by extract-text-webpack-plugin
module.exports = {"Base":"MetaBar__Base-jftOY","Item":"MetaBar__Item-dq2kT","Item--asLink":"MetaBar__Item--asLink-1xEDx MetaBar__Item-dq2kT","ItemLink":"MetaBar__ItemLink-G5STT","Link":"MetaBar__Link-coIOR","Link--featured":"MetaBar__Link--featured-29Y18 MetaBar__Link-coIOR","Link--specialSeries":"MetaBar__Link--specialSeries-3w0iB MetaBar__Link-coIOR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MetaBar/MetaBar.css
 ** module id = 633
 ** module chunks = 0
 **/